/* eslint-disable function-paren-newline*/
import {
    USER_ACTIONS_MAP,
    USER_STATUS,
    USER_LEVEL,
} from '../../../utils/constants/commonValues';
import moment from 'moment';

function UserMaker(data) {
    this.makerData = this.createTableData(data);
    this.makerPagination = this.createPaginationData(data);
}

UserMaker.prototype = Object.assign(UserMaker.prototype, {
    createTableData(tableData) {
        return (
            tableData &&
            tableData.makerCheckerUserResponseDetailDto &&
            tableData.makerCheckerUserResponseDetailDto.map(row =>
                this.createRow(row)
            )
        );
    },
    createPaginationData(data) {
        if (data) {
            const { currentPage, totalRecord } = data;
            return {
                hasNextPage: false,
                hasPreviousPage: false,
                pageNumber: currentPage,
                pageSize: 10,
                sortingCriteria: '',
                totalNumberOfPages: 0,
                totalNumberOfRecords: totalRecord,
            };
        }
        return {};
    },
    createRow(row) {
        const {
            email,
            checkerComment,
            makerComment,
            extUserDetailData,
            newUserDetailData,
            intentFor,
            requestCreationTime,
            requestId,
            makerName,
        } = row;
        const { name } = newUserDetailData;
        return {
            name,
            email,
            checkerComment,
            makerComment,
            extUserDetailData,
            newUserDetailData,
            intentFor,
            requestCreationTime,
            requestId,
            userCreatedUpdatedName: makerName || '-',
            userCreatedDate: this.convertDate(requestCreationTime),
            entityName: this.getEntityName(newUserDetailData),
            entityNameOld: this.getEntityName(extUserDetailData),
            userRoleName: this.getUserRole(newUserDetailData),
            userRoleNameOld: this.getUserRole(extUserDetailData),
            userLevel: this.getUserLevel(newUserDetailData),
            userLevelOld: this.getUserLevel(extUserDetailData),
            userStatus: this.getStatus(newUserDetailData),
            userStatusOld: this.getStatus(extUserDetailData),
            lastActions: this.getLastAction(intentFor),
        };
    },
    convertDate(date) {
        const dateString = moment(date).format('DD/MM/YYYY');
        return dateString;
    },

    getStatus(status) {
        if (status && status.userStatus) {
            return USER_STATUS[status.userStatus];
        }
        return 'Null';
    },

    getEntityName(entity) {
        if (entity && entity.entityName) {
            return entity.entityName;
        }
        return null;
    },

    getUserRole(role) {
        if (role && role.userRole) {
            return role.userRole;
        }
        return null;
    },

    getUserLevel(level) {
        if (level && level.userLevel) {
            return USER_LEVEL[level.userLevel];
        }

        return null;
    },

    getLastAction(action) {
        return USER_ACTIONS_MAP[action] || '-';
    },
});

export default UserMaker;
